import React, { useState, cloneElement } from 'react';
import { SmartphoneIcon, SearchIcon, BarChart2Icon, ArrowRightIcon, LayoutDashboardIcon, BarChart3Icon, UsersIcon, PackageIcon, ShieldIcon, TrendingUpIcon, TrendingDownIcon, FilterIcon, CalendarIcon, CheckIcon, XIcon, AlertTriangleIcon, DollarSignIcon, PhoneIcon, ClockIcon, ListIcon, SettingsIcon, BellIcon, HelpCircleIcon, PlusIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { t } from 'i18next';
const RevenueChart = ({
  period
}) => {
  const getData = () => {
    switch (period) {
      case 'monthly':
        return {
          labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          current: [42000, 45000, 41000, 52000, 58000, 54000, 59000],
          previous: [38000, 39000, 35000, 42000, 44000, 45000, 47000]
        };
      case 'quarterly':
        return {
          labels: ['Q1', 'Q2', 'Q3', 'Q4'],
          current: [145000, 168000, 182000, 195000],
          previous: [125000, 138000, 152000, 162000]
        };
      case 'yearly':
        return {
          labels: ['2020', '2021', '2022', '2023', '2024'],
          current: [520000, 580000, 650000, 720000, 790000],
          previous: [480000, 510000, 570000, 620000, 680000]
        };
      default:
        return {
          labels: [],
          current: [],
          previous: []
        };
    }
  };
  const {
    labels,
    current,
    previous
  } = getData();
  const maxValue = Math.max(...[...current, ...previous]);
  return <div className="relative h-[300px] w-full overflow-x-auto sm:overflow-x-hidden" data-id="element-210">
      <div className="absolute left-0 bottom-0 w-full min-w-[600px] sm:min-w-0 h-[260px] flex items-end gap-4" data-id="element-211">
        {labels.map((label, index) => <div key={index} className="flex-1 flex flex-col items-center group" data-id="element-212">
            <div className="relative w-full flex gap-2 justify-center mb-2" data-id="element-213">
              <div className="w-4 bg-blue-500 dark:bg-brand-green rounded-t transition-all duration-300 hover:opacity-80" style={{
            height: `${current[index] / maxValue * 240}px`
          }} data-id="element-214">
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity bg-gray-900 text-white px-2 py-1 rounded text-xs whitespace-nowrap" data-id="element-215">
                  ${current[index].toLocaleString()}
                </div>
              </div>
              <div className="w-4 bg-gray-300 dark:bg-gray-700 rounded-t transition-all duration-300 hover:opacity-80" style={{
            height: `${previous[index] / maxValue * 240}px`
          }} data-id="element-216">
                <div className="absolute -top-8 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity bg-gray-900 text-white px-2 py-1 rounded text-xs whitespace-nowrap" data-id="element-217">
                  ${previous[index].toLocaleString()}
                </div>
              </div>
            </div>
            <div className="text-xs text-gray-500 dark:text-gray-400 mt-2" data-id="element-218">
              {label}
            </div>
          </div>)}
      </div>
      <div className="absolute top-0 right-0 flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4" data-id="element-219">
        <div className="flex items-center gap-2" data-id="element-220">
          <div className="w-3 h-3 bg-blue-500 dark:bg-brand-green rounded" data-id="element-221"></div>
          <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-222">
            Current Period
          </span>
        </div>
        <div className="flex items-center gap-2" data-id="element-223">
          <div className="w-3 h-3 bg-gray-300 dark:bg-gray-700 rounded" data-id="element-224"></div>
          <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-225">
            Previous Period
          </span>
        </div>
      </div>
    </div>;
};
function BarChart({
  data
}) {
  const maxValue = Math.max(...data.map(item => item.value));
  return <div className="flex items-end h-[200px] gap-2" data-id="element-226">
      {data.map((item, index) => <div key={index} className="flex-1 flex flex-col items-center group" data-id="element-227">
          <div className="relative w-full flex flex-col justify-end h-[160px]" data-id="element-228">
            <div className="w-full bg-blue-500 dark:bg-brand-green rounded-t transition-all duration-300 hover:opacity-80" style={{
          height: `${item.value / maxValue * 160}px`
        }} data-id="element-229" />
            <div className="absolute -top-8 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity z-10" data-id="element-230">
              <div className="bg-gray-900 text-white px-2 py-1 rounded text-xs whitespace-nowrap" data-id="element-231">
                ${item.value.toLocaleString()}
              </div>
            </div>
          </div>
          <div className="mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-232">
            {item.month}
          </div>
        </div>)}
    </div>;
}
function DonutChart({
  data
}) {
  const total = data.reduce((sum, item) => sum + item.count, 0);
  let rotation = 0;
  return <div className="relative w-[200px] h-[200px] mx-auto" data-id="element-233">
      <svg viewBox="0 0 100 100" className="transform -rotate-90" data-id="element-234">
        {data.map((item, index) => {
        const percentage = item.count / total * 100;
        const slice = <circle key={index} cx="50" cy="50" r="40" fill="none" stroke={index % 2 === 0 ? 'rgb(59, 130, 246)' : 'rgb(0, 255, 102)'} strokeWidth="20" strokeDasharray={`${percentage} 100`} style={{
          transformOrigin: '50% 50%',
          transform: `rotate(${rotation}deg)`
        }} className="transition-all duration-300 hover:opacity-80" data-id="element-235" />;
        rotation += percentage * 3.6;
        return slice;
      })}
      </svg>
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-236">
        <div className="text-center" data-id="element-237">
          <div className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-238">
            {total}
          </div>
          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-239">Total</div>
        </div>
      </div>
    </div>;
}
const AnalyticsTab = () => {
  const [period, setPeriod] = useState('monthly');
  return <div className="space-y-6" data-id="element-240">
      <div data-id="element-241">
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-242">
          Revenue Analytics
        </h2>
        <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 p-4 sm:p-6" data-id="element-243">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 sm:gap-0 mb-6" data-id="element-244">
            <div data-id="element-245">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-246">
                Revenue Breakdown
              </h3>
              <p className="text-sm text-gray-500" data-id="element-247">
                Last 30 days vs previous period
              </p>
            </div>
            <div className="w-full sm:w-auto overflow-x-auto" data-id="element-248">
              <div className="flex items-center space-x-2 min-w-[300px] sm:min-w-0" data-id="element-249">
                {[{
                id: 'monthly',
                label: 'Monthly'
              }, {
                id: 'quarterly',
                label: 'Quarterly'
              }, {
                id: 'yearly',
                label: 'Yearly'
              }].map(item => <button key={item.id} onClick={() => setPeriod(item.id)} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors flex-1 sm:flex-none whitespace-nowrap ${period === item.id ? 'bg-blue-600 dark:bg-brand-green text-white dark:text-black' : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'}`} data-id="element-250">
                    {item.label}
                  </button>)}
              </div>
            </div>
          </div>
          <RevenueChart period={period} data-id="element-251" />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mt-8" data-id="element-252">
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-253">
              <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-254">
                Total Revenue
              </h4>
              <div className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-255">
                $48,294
              </div>
              <div className="text-sm text-green-600" data-id="element-256">+8.7% vs last period</div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-257">
              <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-258">
                Average Trade Value
              </h4>
              <div className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-259">
                $412
              </div>
              <div className="text-sm text-green-600" data-id="element-260">+4.2% vs last period</div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4" data-id="element-261">
              <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-262">
                Trade-In Volume
              </h4>
              <div className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-263">
                117
              </div>
              <div className="text-sm text-red-600" data-id="element-264">-3.1% vs last period</div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
function DashboardContent() {
  const volumeData = [{
    month: 'Mon',
    value: 120
  }, {
    month: 'Tue',
    value: 145
  }, {
    month: 'Wed',
    value: 135
  }, {
    month: 'Thu',
    value: 160
  }, {
    month: 'Fri',
    value: 180
  }, {
    month: 'Sat',
    value: 140
  }, {
    month: 'Sun',
    value: 155
  }];
  const distributionData = [{
    model: 'iPhone',
    count: 45
  }, {
    model: 'Samsung',
    count: 32
  }, {
    model: 'Others',
    count: 23
  }];
  return <div className="space-y-6" data-id="element-265">
      <div className="flex justify-between items-center" data-id="element-266">
        <div data-id="element-267">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-1" data-id="element-268">
            Dashboard Overview
          </h2>
          <p className="text-sm text-gray-500" data-id="element-269">
            Welcome back, Admin • Last login 2 hours ago
          </p>
        </div>
        <div className="flex items-center space-x-3" data-id="element-270">
          <div className="relative" data-id="element-271">
            <input type="text" placeholder="Search devices..." className="pl-9 pr-4 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-900 dark:text-white rounded-md text-sm focus:ring-blue-500 dark:focus:ring-brand-green focus:border-blue-500 dark:focus:border-brand-green placeholder-gray-500 w-48 transition-all focus:w-64" data-id="element-272" />
            <SearchIcon className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-273" />
          </div>
          <Button className="flex items-center space-x-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300" data-id="element-274">
            <FilterIcon className="h-4 w-4" data-id="element-275" />
            <span data-id="element-276">Filters</span>
          </Button>
          <Button className="flex items-center space-x-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300" data-id="element-277">
            <CalendarIcon className="h-4 w-4" data-id="element-278" />
            <span data-id="element-279">Today</span>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-280">
        <StatCard title="Total Devices" value="1,248" change="+12.5%" isPositive={true} icon={<PhoneIcon className="h-5 w-5 text-blue-600 dark:text-brand-green" data-id="element-282" />} data-id="element-281" />
        <StatCard title="Pending Trades" value="38" change="-4.3%" isPositive={false} icon={<ClockIcon className="h-5 w-5 text-orange-500" data-id="element-284" />} data-id="element-283" />
        <StatCard title="Revenue" value="$48,294" change="+8.7%" isPositive={true} icon={<DollarSignIcon className="h-5 w-5 text-green-500" data-id="element-286" />} data-id="element-285" />
        <StatCard title="Active Users" value="845" change="+23.1%" isPositive={true} icon={<UsersIcon className="h-5 w-5 text-purple-500" data-id="element-288" />} data-id="element-287" />
      </div>
      <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800" data-id="element-289">
        <div className="p-6" data-id="element-290">
          <div className="flex justify-between items-center mb-6" data-id="element-291">
            <div data-id="element-292">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-293">
                Recent Trade-In Activity
              </h3>
              <p className="text-sm text-gray-500" data-id="element-294">
                Latest device assessments and trade-ins
              </p>
            </div>
            <Button variant="link" className="text-blue-600 dark:text-brand-green" data-id="element-295">
              View All
            </Button>
          </div>
          <div className="overflow-x-auto" data-id="element-296">
            <table className="w-full" data-id="element-297">
              <thead data-id="element-298">
                <tr className="text-left border-b border-gray-200 dark:border-gray-800" data-id="element-299">
                  <th className="pb-3 font-medium text-gray-500" data-id="element-300">DEVICE</th>
                  <th className="pb-3 font-medium text-gray-500" data-id="element-301">CUSTOMER</th>
                  <th className="pb-3 font-medium text-gray-500" data-id="element-302">VALUE</th>
                  <th className="pb-3 font-medium text-gray-500" data-id="element-303">STATUS</th>
                  <th className="pb-3 font-medium text-gray-500" data-id="element-304">DATE</th>
                  <th className="pb-3 font-medium text-gray-500" data-id="element-305"></th>
                </tr>
              </thead>
              <tbody data-id="element-306">
                {[{
                device: 'iPhone 13 Pro',
                customer: 'Alex Johnson',
                value: '$520',
                status: 'pending',
                date: 'Today, 10:45 AM'
              }, {
                device: 'Samsung S22',
                customer: 'Maria Garcia',
                value: '$410',
                status: 'completed',
                date: 'Yesterday'
              }, {
                device: 'Google Pixel 6',
                customer: 'Robert Chen',
                value: '$340',
                status: 'rejected',
                date: 'May 24, 2024'
              }, {
                device: 'iPhone 12',
                customer: 'Sarah Williams',
                value: '$280',
                status: 'processing',
                date: 'May 23, 2024'
              }].map((item, index) => <tr key={index} className="border-b border-gray-200 dark:border-gray-800" data-id="element-307">
                    <td className="py-4 text-gray-900 dark:text-white" data-id="element-308">
                      {item.device}
                    </td>
                    <td className="py-4 text-gray-500" data-id="element-309">{item.customer}</td>
                    <td className="py-4 font-medium text-gray-900 dark:text-white" data-id="element-310">
                      {item.value}
                    </td>
                    <td className="py-4" data-id="element-311">
                      <StatusBadge status={item.status} data-id="element-312" />
                    </td>
                    <td className="py-4 text-gray-500" data-id="element-313">{item.date}</td>
                    <td className="py-4 text-right" data-id="element-314">
                      <button className="text-blue-600 dark:text-brand-green hover:underline" data-id="element-315">
                        View
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-316">
        <ChartCard title="Trade-In Volume" subtitle="Last 7 days" chart={<BarChart data={volumeData} data-id="element-318" />} data-id="element-317" />
        <ChartCard title="Device Distribution" subtitle="By manufacturer" chart={<DonutChart data={distributionData} data-id="element-320" />} data-id="element-319" />
      </div>
    </div>;
}
function StatusBadge({
  status
}) {
  const styles = {
    pending: 'bg-yellow-50 text-yellow-800 border-yellow-200',
    completed: 'bg-green-50 text-green-800 border-green-200',
    processing: 'bg-blue-50 text-blue-800 border-blue-200',
    rejected: 'bg-red-50 text-red-800 border-red-200'
  };
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles[status]}`} data-id="element-321">
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>;
}
function StatCard({
  title,
  value,
  change,
  isPositive,
  icon
}) {
  return <div className="bg-white dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-800" data-id="element-322">
      <div className="flex items-center justify-between mb-4" data-id="element-323">
        <span className="text-sm text-gray-500" data-id="element-324">{title}</span>
        <div className="p-2 rounded-lg bg-gray-50 dark:bg-gray-800" data-id="element-325">{icon}</div>
      </div>
      <div className="flex items-end justify-between" data-id="element-326">
        <span className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-327">
          {value}
        </span>
        <span className={`flex items-center text-sm font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-328">
          {isPositive ? <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-329" /> : <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-330" />}
          {change}
        </span>
      </div>
    </div>;
}
function ChartCard({
  title,
  subtitle,
  chart
}) {
  return <div className="bg-white dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-800" data-id="element-331">
      <div className="flex items-center justify-between mb-4" data-id="element-332">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-333">
          {title}
        </h3>
        <p className="text-sm text-gray-500" data-id="element-334">{subtitle}</p>
      </div>
      <div className="h-64" data-id="element-335">{chart}</div>
    </div>;
}
export function DashboardPreviewTabs() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const tabs = [{
    id: 'dashboard',
    label: t('dashboard'),
    icon: <LayoutDashboardIcon className="h-4 w-4" data-id="element-336" />
  }, {
    id: 'analytics',
    label: t('analytics'),
    icon: <BarChart3Icon className="h-4 w-4" data-id="element-337" />
  }, {
    id: 'inventory',
    label: t('inventory'),
    icon: <PackageIcon className="h-4 w-4" data-id="element-338" />
  }, {
    id: 'customers',
    label: t('customers'),
    icon: <UsersIcon className="h-4 w-4" data-id="element-339" />
  }, {
    id: 'risk',
    label: t('risk'),
    icon: <ShieldIcon className="h-4 w-4" data-id="element-340" />
  }];
  return <section id="business-platform" className="bg-gray-50 dark:bg-black text-gray-900 dark:text-white py-20" data-id="element-341">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-342">
        <div className="text-center mb-12" data-id="element-343">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-344">
            <LayoutDashboardIcon className="h-4 w-4 mr-2" data-id="element-345" />
            {t('managementDashboard.badge')}
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-346">
            {t('managementDashboard.title')}
            <span className="text-blue-600 dark:text-brand-green" data-id="element-347">
              {t('managementDashboard.subtitle')}
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-348">
            {t('managementDashboard.description')}
          </p>
        </div>
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl overflow-hidden border border-gray-200 dark:border-gray-800" data-id="element-349">
          <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-800 px-4" data-id="element-350">
            <div className="flex flex-wrap -mb-px" data-id="element-351">
              {tabs.map(tab => <button key={tab.id} className={`group px-6 py-4 text-sm font-medium flex items-center border-b-2 transition-all duration-200 ${activeTab === tab.id ? 'text-blue-600 dark:text-brand-green border-blue-600 dark:border-brand-green' : 'text-gray-500 dark:text-gray-400 border-transparent hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-700'}`} onClick={() => setActiveTab(tab.id)} data-id="element-352">
                  {cloneElement(tab.icon, {
                className: `mr-2 h-4 w-4 transition-transform group-hover:scale-110 ${activeTab === tab.id ? 'text-blue-600 dark:text-brand-green' : ''}`
              })}
                  {tab.label}
                </button>)}
            </div>
            <div className="flex items-center space-x-2" data-id="element-353">
              <button className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors relative group" data-id="element-354">
                <BellIcon className="h-5 w-5" data-id="element-355" />
                <span className="absolute -top-1 -right-1 h-4 w-4 bg-blue-600 dark:bg-brand-green text-white dark:text-black text-xs rounded-full flex items-center justify-center" data-id="element-356">
                  3
                </span>
              </button>
              <button className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors" data-id="element-357">
                <HelpCircleIcon className="h-5 w-5" data-id="element-358" />
              </button>
              <button className="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors" data-id="element-359">
                <SettingsIcon className="h-5 w-5" data-id="element-360" />
              </button>
            </div>
          </div>
          <div className="p-6" data-id="element-361">
            {activeTab === 'dashboard' && <DashboardContent data-id="element-362" />}
            {activeTab === 'analytics' && <AnalyticsTab data-id="element-363" />}
            {activeTab === 'inventory' && <div className="space-y-6" data-id="element-364">
                <div data-id="element-365">
                  <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-366">
                    Inventory Management
                  </h2>
                  <div className="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800" data-id="element-367">
                    <div className="p-6" data-id="element-368">
                      <div className="flex justify-between items-center mb-6" data-id="element-369">
                        <div data-id="element-370">
                          <h3 className="text-lg font-medium text-gray-900 dark:text-white" data-id="element-371">
                            Device Inventory
                          </h3>
                          <p className="text-sm text-gray-500" data-id="element-372">
                            Current stock and availability
                          </p>
                        </div>
                        <Button className="bg-blue-600 dark:bg-brand-green hover:bg-blue-700 dark:hover:bg-brand-green/90 text-white dark:text-black" data-id="element-373">
                          <PlusIcon className="h-4 w-4 mr-2" data-id="element-374" />
                          Add Devices
                        </Button>
                      </div>
                      <div className="overflow-x-auto" data-id="element-375">
                        <table className="w-full" data-id="element-376">
                          <thead data-id="element-377">
                            <tr className="text-left border-b border-gray-200 dark:border-gray-800" data-id="element-378">
                              <th className="pb-3 font-medium text-gray-500" data-id="element-379">
                                MODEL
                              </th>
                              <th className="pb-3 font-medium text-gray-500" data-id="element-380">
                                STOCK
                              </th>
                              <th className="pb-3 font-medium text-gray-500" data-id="element-381">
                                AVG PRICE
                              </th>
                              <th className="pb-3 font-medium text-gray-500" data-id="element-382">
                                STATUS
                              </th>
                              <th className="pb-3 font-medium text-gray-500" data-id="element-383">
                                UPDATED
                              </th>
                            </tr>
                          </thead>
                          <tbody data-id="element-384">
                            {[{
                          model: 'iPhone 13 Pro',
                          stock: 45,
                          avgPrice: '$599',
                          status: 'In Stock',
                          updated: '2 hours ago'
                        }, {
                          model: 'Samsung S22',
                          stock: 32,
                          avgPrice: '$449',
                          status: 'Low Stock',
                          updated: '5 hours ago'
                        }, {
                          model: 'iPhone 12',
                          stock: 28,
                          avgPrice: '$399',
                          status: 'In Stock',
                          updated: '1 day ago'
                        }, {
                          model: 'Google Pixel 6',
                          stock: 15,
                          avgPrice: '$349',
                          status: 'Critical',
                          updated: '3 days ago'
                        }].map((item, index) => <tr key={index} className="border-b border-gray-200 dark:border-gray-800" data-id="element-385">
                                <td className="py-4 text-gray-900 dark:text-white" data-id="element-386">
                                  {item.model}
                                </td>
                                <td className="py-4 text-gray-900 dark:text-white" data-id="element-387">
                                  {item.stock}
                                </td>
                                <td className="py-4 text-gray-900 dark:text-white" data-id="element-388">
                                  {item.avgPrice}
                                </td>
                                <td className="py-4" data-id="element-389">
                                  <StatusBadge status={item.status.toLowerCase()} data-id="element-390" />
                                </td>
                                <td className="py-4 text-gray-500" data-id="element-391">
                                  {item.updated}
                                </td>
                              </tr>)}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}